<div class="title">
  <ion-label color="dark"> <span>●</span>{{ title }}<span>●</span></ion-label>
</div>
